/**
 * Dailymotion video library — constants.
 *
 * FR-only feature: it targets the French Foot Mercato Dailymotion channels.
 * Everything here is hardcoded on purpose (no per-locale config, no backend
 * proxy) — the public Dailymotion Data API is read directly from the browser
 * (CORS is open, anonymous read is allowed). No API key ships in the bundle.
 */

/** Public Dailymotion Data API root. */
export const DM_API_BASE = 'https://api.dailymotion.com';

export interface IDmChannel {
  /** Dailymotion user (channel) id — what the `owners` filter expects. */
  id: string;
  /** Label shown in the channel tag of each video card. */
  label: string;
}

/**
 * Channels listed in the library. By default they are merged into ONE globally
 * sorted, paginated list through the `owners` filter of `GET /videos`; the
 * channel filter of the UI narrows `owners` to a single channel.
 */
export const DM_CHANNELS: IDmChannel[] = [
  { id: 'x171qjm', label: 'Foot Mercato' },
  { id: 'xnhjrv', label: 'Evidence Production' },
];

/** Channel filter value meaning "all channels" (default). */
export const DM_ALL_CHANNELS = '';

/**
 * Body-article player. MUST stay `x6svc`: this is the iframe player that
 * footmercato's render pipeline (ContentHelper / ParsedownExtension) detects
 * and re-enriches (prebid / sticky / mute) when the embed is pasted in an
 * article body. Do NOT use the canonical `www.dailymotion.com/embed/video/<id>`
 * (SEO/sitemap only) nor the header player `x165ku`.
 */
export const DM_BODY_PLAYER = 'x6svc';

/** Page size — paginate by 100 (also the API hard maximum for `limit`). */
export const DM_PAGE_SIZE = 100;

/** The API rejects `page` > 100 (HTTP 400): requested pages are clamped to it. */
export const DM_MAX_PAGE = 100;

/**
 * The API stops at 1,000 results per query (verified 2026-10-01: with
 * limit=100, page 10 answers has_more=false and page 11 is empty). Reaching it
 * means "refine the search", not "end of results".
 */
export const DM_MAX_RESULTS = 1000;

/** Sort modes exposed by the API; default = most recent first. */
export type DmSort = 'recent' | 'relevance' | 'visited';
export const DM_SORTS: DmSort[] = ['recent', 'relevance', 'visited'];
export const DM_DEFAULT_SORT: DmSort = 'recent';

/**
 * Fields requested from the API (kept minimal for payload size).
 * `owner` (channel id) drives the channel tag, `owner.screenname` is its
 * fallback label, `allow_embed` filters out videos the player cannot play.
 */
export const DM_FIELDS =
  'id,title,description,duration,created_time,views_total,thumbnail_360_url,private,owner,owner.screenname,allow_embed';
